export default class ScrollTopButton {
    static init(): void {
        const scrollToTopBtn = document.querySelector('.scroll-top-button');

        if (!scrollToTopBtn) {
            return;
        }

        // Zobrazit/skrýt tlačítko při scrollování
        window.addEventListener('scroll', () => {
            // Zobrazit po scrollu 100vh (výška viewportu)
            if (window.scrollY > window.innerHeight) {
                scrollToTopBtn.classList.add('show');
            } else {
                scrollToTopBtn.classList.remove('show');
            }
        });

        // Scroll nahoru po kliknutí
        scrollToTopBtn.addEventListener('click', () => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        });
    }
}
